import React, { useEffect } from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { Footer } from '../components/Footer';
import { ScrollToTop } from '../components/ScrollToTop';
import { places } from '../data/places';
export function WildlifeNaturePage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const wildlifePlaces = places.filter(p => p.categories.includes('Wildlife') || p.categories.includes('Nature') || p.categories.includes('Adventure'));
  return <div className="min-h-screen bg-white" data-id="element-1424">
      {/* Hero */}
      <div className="border-b border-gray-200" data-id="element-1425">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 py-20 md:py-32" data-id="element-1426">
          <motion.div initial={{
          y: 20,
          opacity: 0
        }} animate={{
          y: 0,
          opacity: 1
        }} transition={{
          duration: 0.6
        }} className="max-w-3xl" data-id="element-1427">
            <h1 className="text-5xl md:text-7xl font-semibold text-charcoal mb-6 leading-tight" data-id="element-1428">
              Wildlife & Nature
            </h1>
            <p className="text-xl md:text-2xl text-gray-600 leading-relaxed" data-id="element-1429">
              Where wild Africa meets urban sophistication. Experience nature
              like nowhere else on Earth.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16" data-id="element-1430">
        {/* Introduction */}
        <section className="mb-20" data-id="element-1431">
          <div className="max-w-3xl" data-id="element-1432">
            <p className="text-gray-700 text-lg leading-relaxed mb-6" data-id="element-1433">
              Nairobi defies convention. This is a city where you can watch
              lions hunt zebra in the morning and attend a business meeting in a
              glass tower by afternoon. Where endangered giraffes peer over
              garden walls and urban forests provide sanctuary for over 400 bird
              species. It's a unique juxtaposition that exists nowhere else—a
              thriving metropolis that hasn't forgotten its wild roots.
            </p>
            <p className="text-gray-700 leading-relaxed" data-id="element-1434">
              The city's commitment to conservation is evident everywhere. From
              the Giraffe Centre's breeding program for Rothschild giraffes to
              the David Sheldrick Wildlife Trust's elephant orphanage, Nairobi
              leads Africa in urban wildlife conservation.
            </p>
          </div>
        </section>

        {/* Places */}
        <section data-id="element-1435">
          <h2 className="text-2xl font-semibold text-charcoal mb-8" data-id="element-1436">
            Wildlife & Nature Destinations
          </h2>
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-1437">
            {wildlifePlaces.map((place, index) => <motion.div key={place.id} initial={{
            y: 20,
            opacity: 0
          }} whileInView={{
            y: 0,
            opacity: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: index * 0.1
          }} data-id="element-1438">
                <Link to={`/place/${place.id}`} className="group block" data-id="element-1439">
                  <div className="border border-gray-200 hover:border-charcoal transition-smooth overflow-hidden" data-id="element-1440">
                    <div className="relative aspect-[4/3] overflow-hidden" data-id="element-1441">
                      <img src={place.image} alt={place.name} className="w-full h-full object-cover group-hover:scale-105 transition-smooth" data-id="element-1442" />
                    </div>
                    <div className="p-6" data-id="element-1443">
                      <h3 className="text-xl font-semibold text-charcoal mb-2 group-hover:underline" data-id="element-1444">
                        {place.name}
                      </h3>
                      <p className="text-gray-700 text-sm line-clamp-2 mb-4" data-id="element-1445">
                        {place.description}
                      </p>
                      <div className="flex items-center gap-2 text-charcoal font-medium text-sm" data-id="element-1446">
                        <span data-id="element-1447">Explore</span>
                        <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" strokeWidth={2} data-id="element-1448" />
                      </div>
                    </div>
                  </div>
                </Link>
              </motion.div>)}
          </div>
        </section>
      </div>

      <ScrollToTop data-id="element-1449" />
      <Footer data-id="element-1450" />
    </div>;
}